import React,  {useState} from 'react'
import PropTypes from "prop-types"
import { navigate } from 'gatsby'

import * as S from './styles'
import Image from '../Image'
import { Button, RichText } from 'components'
import ModalVideos from '../ModalVideos'
import { useActiveValue } from "../../customHooks"
import ModalContent from '../ModalContent'



const Card = ({title, image, date, videos, text, modal, cta}) => {
  const [isModalContentVisible, setModalContentVisible] = useState(null)

  const {
    activeValue,
    setNext,
    setPre,
    onCancel,
    setValue
  } = useActiveValue({maxValue: videos?.length})

  function hancleCtaClick(){


    if(cta?.slug.indexOf("https") > -1 || cta?.slug?.indexOf("http") > -1) {
      window.location.href = cta.slug
      return
    }

    if(cta?.slug){
      navigate(cta.slug)
      return
    }

    if(modal?.title || modal?.text || modal?.images ){
      setModalContentVisible(true)

      return
    }

  }

  return (
    <S.Card>
      <S.ImageContent>
        <Image image={image} />
      </S.ImageContent>
      <S.Content>
        {title && <S.Title>{title}</S.Title>}
        {date && <S.Date>{date}</S.Date>}
        {videos?.length > 0 && <S.VideoButtonWrapper><Button onClick={() => setValue(0)} type={null} icon="play-circle" >Play video </Button></S.VideoButtonWrapper>}
        <S.Text><RichText text={text} /></S.Text>
        {modal && (
          <ModalContent
            visible={isModalContentVisible}
            onCancel={()=> setModalContentVisible(null)} 
            {...modal}
          />
        )}
        {videos?.length > 0 && <ModalVideos
            videos={videos}
            activeValue={activeValue}
            onCancel={onCancel}
            setNext={setNext}
            setPre={setPre}
          />}

        {cta && (
          <S.CtaWrapper>
            <Button type="link" size="large" icon={cta.icon} onClick={hancleCtaClick}>{cta.label}</Button>
          </S.CtaWrapper>
        )}

      </S.Content>
    </S.Card>
  )
}


Card.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.string,
  text: PropTypes.string.isRequired,
  image:  PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  videos: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    color: PropTypes.string,
    src: PropTypes.string,
  })),
  inverted: PropTypes.bool,
  cta:  PropTypes.shape({
    slug: PropTypes.string,
    label: PropTypes.string,
    icon: PropTypes.string,
  }),
  modal: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
    }))
  })
}

export default Card
